module.exports = __webpack_public_path__ + "img/text-effect-arch.2cef6b45.png";